import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyAndDeleteHorseSlice = createSlice({
    name: 'VerifyAndDeleteHorse',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyAndDeleteHorse.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyAndDeleteHorse.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyAndDeleteHorse.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyAndDeleteHorse , setStatus} = getVerifyAndDeleteHorseSlice.actions;
export default getVerifyAndDeleteHorseSlice.reducer;

export const fetchVerifyAndDeleteHorse = createAsyncThunk('/getVerifyAndDeleteHorse/fetch', async({id}) => {
    const res = await axios.delete(`${window.env.API_URL}/VerifyAndDeleteHorse/${id}`);
    const VerifyAndDeleteHorseData = res.data;
    return VerifyAndDeleteHorseData.data;
})